// extracted by mini-css-extract-plugin
export default {"appsFacepileContainer":"AppsFacepile_appsFacepileContainer__GeHvt","appIconFacepile":"AppsFacepile_appIconFacepile__pAtjZ","appIcon":"AppsFacepile_appIcon__EQZOz"};